<template src="./index.html"></template>

<script>
import { mapState } from 'vuex';
import { Toast } from "vant";
export default {
    name: 'CouponsPopup',
    components: {
        Toast
    },
    data() {
        return {
            popupShow: false,
            defferScroll: function (event) {
                event.preventDefault()
            },

            flags: false,
            position: { x: 0, y: 0 },
            nx: '', ny: '', dx: '', dy: '', xPum: '', yPum: '',
            listArr: [],
            imgBtnShow: true
        }
    },
    computed:{
        ...mapState({
            xPumValue01: (state)=>{
                return state.MessageSwitch.xPumValue01
            },
            yPumValue01: (state)=>{
                return state.MessageSwitch.yPumValue01
            },
            UserInfo: (state) => {
                return state.Public.UserInfo;
            },
            popupType: (state) => {
                return state.Public.popupType;
            },
        })
    },
    mounted() {
        this.listArr = this.UserInfo.CanUpdateCouponInfo
        
        if(this.xPumValue01!=='0' || this.yPumValue01!=='0') {
            moveBox.style.left = this.xPumValue01;
            moveBox.style.top = this.yPumValue01;
        }
        // console.log(this.listArr)
        // this.UserInfo.popup_switch = 1

        if(this.UserInfo.popup_switch == 1 && !this.popupType) {
            // this.popupShow = true
            this.$store.dispatch("CouponPage/receiveUpdateCoupon", {}).then(res=>{
                if(res.code == 1000 || res.code == 5013) {
                    let v_id = res.data.v_id
                    sessionStorage.setItem('stroe_id', v_id);
                    this.popupShow = true
                }else {
                    Toast(res.message)
                }
            });
            this.$store.commit("Public/SET_DATA",{key:'popupType', data: true})
        }
        if(this.UserInfo.float_switch == "0" && this.UserInfo.popup_switch == "0") {
            this.imgBtnShow = false
        }
    },
    methods: {
        showBtn() {
            
            document.body.addEventListener("touchmove", this.defferScroll, {passive: false});
            document.body.addEventListener("wheel", this.defferScroll, {passive: false});
            
            let data = {
                page_from:'main_page',
                page_name:'MessageSwitch',
                btn_name: 'PopupImgBtn',
                page_time:'0.00',
                receiver_id: '',
                page_param:{},
            };
            this.$store.dispatch('Public/inH5Record', data)

            this.$store.dispatch("CouponPage/receiveUpdateCoupon", {}).then(res=>{
                if(res.code == 1000 || res.code == 5013) {
                    let v_id = res.data.v_id
                    sessionStorage.setItem('stroe_id', v_id);
                    this.popupShow = true
                }else {
                    Toast(res.message)
                }
            });
        },
        closeBtn() {
            this.popupShow = false
            this.imgBtnShow = true
            document.body.removeEventListener("touchmove", this.defferScroll, {passive: false});
            document.body.removeEventListener("wheel", this.defferScroll, {passive: false});
        },
        footerBtn() {
            let data = {
                page_from:'main_page',
                page_name:'MessageSwitch',
                btn_name: 'CouponsPopupFooterBtn',
                page_time:'0.00',
                receiver_id: '',
                page_param:{},
            };
            
            this.$store.dispatch('Public/inH5Record', data).then(res=> {
                // this.$router.push({name:"CouponPage"});
                this.$router.push({ path:'CouponPage', query:{from:'CouponsPopup'}})
            })
            
            
            
        },




        // 实现移动端拖拽
        down(event){
            this.flags = true;
            var touch;
            if(event.touches){
                touch = event.touches[0];
            }else {
                touch = event;
            }
            this.position.x = touch.clientX;
            this.position.y = touch.clientY;
            
            this.dx = moveBox.offsetLeft;
            this.dy = moveBox.offsetTop;
        },
        move(event){
            if(this.flags){
                var touch ;
                if(event.touches){
                    touch = event.touches[0];
                }else {
                    touch = event;
                }
                this.nx = touch.clientX - this.position.x;
                this.ny = touch.clientY - this.position.y;
                this.xPum = this.dx+this.nx;
                this.yPum = this.dy+this.ny;
                let pageWidth = document.documentElement.clientWidth - moveBox.clientWidth
                let pageHeight = document.documentElement.clientHeight - imgBtn.clientHeight
                if(this.xPum < 0) {
                    this.xPum = 0
                }
                if(this.xPum > pageWidth) {
                    this.xPum = pageWidth
                }
                if(this.yPum < 0) {
                    this.yPum = 0
                }
                if(this.yPum > pageHeight) {
                    this.yPum = pageHeight
                }
                moveBox.style.left = this.xPum+"px";
                moveBox.style.top = this.yPum +"px";
                this.$store.commit('MessageSwitch/SET_DATA',{key:'xPumValue01',data:this.xPum+"px"})
                this.$store.commit('MessageSwitch/SET_DATA',{key:'yPumValue01',data:this.yPum +"px"})
                
                document.body.addEventListener("touchmove", this.defferScroll, {passive: false});
                document.body.addEventListener("wheel", this.defferScroll, {passive: false});
            }
        },
        //鼠标释放时候的函数
        end(){
            this.flags = false;
            document.body.removeEventListener("touchmove", this.defferScroll, {passive: false});
            document.body.removeEventListener("wheel", this.defferScroll, {passive: false});
        },
    },
    beforeDestroy() {
        this.closeBtn()
    }
}
</script>

<style lang="scss" src="./index.scss" scoped></style>